import React from 'react';
import colors from 'seagull/foundations/colors.module.scss';
export function PaymentMethod() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9608 2.06008L5.46078 4.12008C4.41078 4.52008 3.55078 5.76008 3.55078 6.89008V14.9901C3.55078 15.8001 4.08078 16.8701 4.73078 17.3501L10.2308 21.4601C11.2008 22.1901 12.7908 22.1901 13.7608 21.4601L19.2608 17.3501C19.9108 16.8601 20.4408 15.8001 20.4408 14.9901V6.89008C20.4408 5.77008 19.5808 4.52008 18.5308 4.13008L13.0308 2.07008C12.4708 1.85008 11.5308 1.85008 10.9608 2.06008Z",
    fill: colors.purple300
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6602 14.23C10.4702 14.23 10.2802 14.16 10.1302 14.01L8.52023 12.4C8.23023 12.11 8.23023 11.63 8.52023 11.34C8.81023 11.05 9.29023 11.05 9.58023 11.34L10.6602 12.42L14.4302 8.65C14.7202 8.36 15.2002 8.36 15.4902 8.65C15.7802 8.94 15.7802 9.42 15.4902 9.71L11.1902 14.01C11.0402 14.16 10.8502 14.23 10.6602 14.23Z",
    fill: colors.purple800
  }));
}